import { combineReducers } from '@reduxjs/toolkit';

import { reducer as jobDescription } from '../CreateJobRequest/slice';
import { reducer as applications } from '../slices/applications/slice';
import { reducer as calendar } from '../slices/calendar/slice';
import { reducer as dashboard } from '../slices/dashboard/slice';
import { reducer as interviews } from '../slices/interviews/slice';
import { reducer as jobRequests } from '../slices/jobRequests/slice';

export const reducer = combineReducers({
  jobRequests,
  jobDescription,
  dashboard,
  applications,
  interviews,
  calendar,
});
